export const API_BASE_URL = '/api/generic-onboarding/v2/';

export enum ApiPath {
  CALCULATE = 'calculate',
  SAVE = 'save',
  PROPOSE = 'propose',
  BIND = 'bind',
}

export const SESSION_ID_HEADER_NAME = 'x-session-id';
export const PRODUCT_ID_HEADER_NAME = 'x-product-id';
export const TENANT_ID_HEADER_NAME = 'x-tenant-id';
